export enum ProcessType {
  Extrusion = 'Extrusion',
  Thermoforming = 'Thermoforming',
  Thermooven = 'Thermooven',
  LeakCheck = 'LeakCheck',
}
